import styled from 'styled-components/macro';

import ShapeIcon from 'components/ShapeSelector/ShapeIcon';

const Scissors = styled(ShapeIcon)`
  right: 0;
  top: 0;
`;

export default Scissors;
